'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SENDING = exports.SENDING = 'SENDING';
var SENT = exports.SENT = 'SENT';
var DELIVERED = exports.DELIVERED = 'DELIVERED';
var READ = exports.READ = 'READ';
//# sourceMappingURL=MessageReceiptState.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/consts/MessageReceiptState.js
// module id = 384
// module chunks = 0